class BenefitCarousel extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    if (this.dataset.slideCount < 2) return

    const next = this.els.next?.element
    const previous = this.els.previous?.element

    const plugins = [
      window.BAO.Carousel.useInitialised(),
      window.BAO.Carousel.useAutoplay(this.dataset.intervalDuration, {
        pauseOnHover: true,
      }),
    ]

    if (next && previous) {
      plugins.push(window.BAO.Carousel.useArrows({ next, previous }))
    }

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
          disabled: Number(this.dataset.slideCount) < 1,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: 2,
              disabled: Number(this.dataset.slideCount) < 2,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md}px)`]: {
            slides: {
              perView: 1,
              disabled: Number(this.dataset.slideCount) < 1,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.xlg}px)`]: {
            slides: {
              perView: 2,
              disabled: Number(this.dataset.slideCount) < 2,
            },
          },
        },
      },
      plugins,
    )
  }
}

if (!customElements.get('benefit-carousel')) {
  customElements.define('benefit-carousel', BenefitCarousel)
}
